import { render } from "./series-pack-item.vue?vue&type=template&id=06c32af8"
import script from "./series-pack-item.vue?vue&type=script&lang=js"
export * from "./series-pack-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__